<div class="profile-addresses relative">
  <!-- Loading state -->
  <div *ngIf="loading" class="flex justify-center py-32">
    <fun-spinner></fun-spinner>
  </div>

  <!-- Saving overlay -->
  <div *ngIf="saving" class="absolute inset-0 bg-white/[0.7] z-20 flex justify-center items-center rounded-xl">
    <fun-spinner></fun-spinner>
  </div>

  <!-- Lista de direcciones -->
  <div *ngIf="!loading">
    <div class="addresses-header flex justify-between items-center mb-16">
      <fun-new-button *ngIf="hasAddresses()" [size]="'l'" [buttonType]="'secondaryDark'" (eventClick)="onAddAddress()"
        title="Añadir dirección" icon="plus-circle" [iconPosition]="'left'"></fun-new-button>
    </div>

    <!-- Empty state -->
    <div *ngIf="!hasAddresses()"
      class="empty-state bg-white rounded-xl p-32 text-center border border-dashed border-eggplant-100/[0.25]">
      <fun-icon [name]="'map-pin'"
        [style]="'w-48 h-48 stroke-[2px] stroke-eggplant-100/[0.3] mx-auto mb-16'"></fun-icon>
      <p class="font-sans text-eggplant-100/[0.6] text-l mb-16">
        No tienes direcciones registradas
      </p>
      <fun-new-button [size]="'m'" [buttonType]="'colorFull'" (eventClick)="onAddAddress()" title="Añadir dirección"
        icon="plus-circle" [iconPosition]="'left'"></fun-new-button>
    </div>

    <!-- Addresses list -->
    <div *ngIf="hasAddresses()" class="addresses-list flex flex-col gap-12">

      <!-- Profile Tax Address (from profile) - Sin CTA de edición -->
      <div *ngIf="hasProfileTaxAddress()"
        class="address-card bg-white rounded-xl p-16 border border-eggplant-100/[0.1]">
        <div class="flex items-start gap-12">
          <!-- Icon -->
          <div class="address-icon flex-shrink-0 w-40 h-40 rounded-full flex items-center justify-center">
            <fun-icon [name]="'home'" [style]="'w-20 h-20 stroke-[4px] stroke-eggplant-100'"></fun-icon>
          </div>

          <!-- Content -->
          <div class="flex-1 min-w-0">
            <!-- Title row with tag aligned right -->
            <div class="flex items-center justify-between gap-8">
              <span class="font-sans text-eggplant-100 text-l">
                Dirección fiscal
              </span>
              <div class="flex items-center gap-8">
                <div class="cursor-pointer" (click)="onEditTaxAddress()">
                  <fun-icon [name]="'edit-3'" [style]="'w-20 h-20 stroke-[2px] stroke-eggplant-100'"></fun-icon>
                </div>
                <span
                  class="text-s font-sans px-8 py-2 rounded-full border text-eggplant-100/[0.5] border-eggplant-100/[0.25]">
                  Principal
                </span>
              </div>
            </div>
            <p class="font-sans text-eggplant-100/[0.7] text-m truncate mt-4">
              {{ formatProfileTaxAddress() }}
            </p>
          </div>
        </div>
      </div>

      <!-- Additional addresses (ExtraAddress) -->
      <div *ngFor="let address of addresses"
        class="address-card bg-white rounded-xl p-16 border border-eggplant-100/[0.1] transition-all duration-200">

        <div class="flex items-start gap-12">
          <!-- Icon -->
          <div class="address-icon flex-shrink-0 w-40 h-40 rounded-full flex items-center justify-center">
            <fun-icon [name]="getAddressTypeIcon(address.type)"
              [style]="'w-20 h-20 stroke-[4px] stroke-eggplant-100'"></fun-icon>
          </div>

          <!-- Content -->
          <div class="flex-1 min-w-0">
            <span class="font-sans text-eggplant-100 text-l">
              {{ getAddressTypeName(address.type) }}
            </span>
            <p class="font-sans text-eggplant-100/[0.7] text-m truncate mt-4">
              {{ formatAddress(address) }}
            </p>
          </div>

          <!-- Actions -->
          <div class="flex items-center gap-16 flex-shrink-0">
            <div class="cursor-pointer" (click)="onEditAddress(address)">
              <fun-icon [name]="'edit-3'" [style]="'w-20 h-20 stroke-[2px] stroke-eggplant-100'"></fun-icon>
            </div>
            <div class="cursor-pointer" (click)="onDeleteAddressConfirm(address)">
              <fun-icon [name]="'trash'" [style]="'w-20 h-20 stroke-[2px] stroke-eggplant-100'"></fun-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>